import { Button, Popover } from 'antd';
import React, { useEffect, useState } from 'react';

import './index.less';
import { t } from '../../../languages';
import { EditOutlined } from '@ant-design/icons';

const images = [...Array(40).keys()];

const ContentBody = ({ selectAvatar }) => (
    <div className='avatar-list'>
        {images.map(aI => {
            return <span key={aI} className='avatar' onClick={() => selectAvatar(aI + 1)}> <img src={`./static/avatar/${aI + 1}.jpg`} alt="" /></span>;
        })}
    </div>
);

const AvatarPicker = ({ lang, handleChange, selected, canChange = true }) => {

    const [clicked, setClicked] = useState(false);
    const [selectedAv, setSelectedAv] = useState(selected ? selected : 0);

    useEffect(() => {
        setSelectedAv(selected);
    }, [selected]);


    const hide = (aI) => {
        setSelectedAv(aI);
        setClicked(false);
        if (handleChange) handleChange(aI);
    };

    // console.log('AvatarPicker:', selected, selectedAv);

    if (canChange) {
        return (
            <section className='avatar-picker'>
                <Popover
                    placement="bottom"
                    title={<span>{t(lang, 'Escoge tu avatar')}</span>}
                    content={<ContentBody selectAvatar={hide} />}
                    overlayClassName={'avatar-picker-popover'}
                    open={clicked}
                >
                    <span className='edit'><EditOutlined /></span>
                    <span key={'av'} className='avatar' onClick={() => setClicked(true)}>
                        {selectedAv ? <img src={`./static/avatar/${selectedAv}.jpg`} alt="" /> : null}
                    </span>
                </Popover>
            </section >
        );
    }else {
        return <section className='avatar-picker'><span className='avatar'>
            <img src={`./static/avatar/${selectedAv}.jpg`} alt="" />
        </span></section>;
    }
}
export default AvatarPicker;